/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MembershipCancellation {
    "use strict";

    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.MembershipCancellation> {

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint)
                .then((data) => {
                    this.model = data;
                });
        }

    }
}